import { eventIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { EventPage } from "../calendar/event-page.tsx";
import { loadEvent } from "../calendar/loaders.ts";
import { useViewer } from "../data/hooks.ts";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { eventSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { RecordPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/calendar/events/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  const { at, checklist } = route.useSearch();
  return viewer === null ? (
    <NoAccessPage />
  ) : (
    <EventPage viewer={viewer} eventId={id} at={at} isPreparing={checklist === "new"} />
  );
};

export const Route = createFileRoute("/_app/calendar/events/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(eventIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  validateSearch: eventSearch,
  loader: async ({ context, params }) => loadEvent(context.data, params.id),
  pendingComponent: () => <RecordPending kind="event" />,
  component: Page,
});
